// revi/src/Utils/constants.js

// URL Directa de Cloud Run
const CLOUD_RUN_URL = "canary.api.educa360.net";

// Mantenemos false para producción
let DEVELOPMENT = false;

const BASE_PATH = DEVELOPMENT
  ? "http://localhost:3977"
  : `https://${CLOUD_RUN_URL}`;

const BASE_API = DEVELOPMENT
  ? "http://localhost:3977/api/v1"
  : `https://${CLOUD_RUN_URL}/api/v1`;

const HUB_PATH = "https://educa360.es";

export const ENV = {
  HUB_PATH: HUB_PATH,
  BASE_PATH: BASE_PATH,
  BASE_API: BASE_API,
  TINY_APIKEY: process.env.REACT_APP_TINYMCE_KEY || "",
  PATH_GLB:
    "https://storage.googleapis.com/educa360-legacy-assets/legacy/repopublic-educa360-central/adminweb/glb/",

  API_ROUTES: {
    // Auth & Usuarios
    REGISTER: "auth/register",
    REGISTER_PENDING: "auth/registerPending",
    VERIFY_REGISTRATION: "auth/verifyRegistration",
    VERIFY: "auth/verify",
    RESEND_CODE: "auth/resendCode",
    LOGIN: "auth/login",
    REFRESH_ACCESS_TOKEN: "auth/refresh_access_token",
    USER_ME: "user/me",
    USER: "user",
    USERS: "users",

    // Rutas Revi
    INSTITUTION: "institutionrevi", // Se usa para operaciones genéricas o listar hijos
    INSTITUTIONBYINSTITUTION: "institutionrevi",
    INSTITUTION_PROFILE: "institutionreviprofile", // <--- NUEVA CONSTANTE CRÍTICA
    THERAPIST_REVI: "therapistrevi",
    PATIENT_REVI: "patientrevi",
    PATIENT_REVI_PROFILE: "patientreviprofile",
    THERAPY: "therapy-category",
    THERAPY_ROUTE_REVI: "therapyroutesrevi",
    REVI_RESOURCE: "revi-resource",
    // Cuestionarios
    YESNO_QUESTIONNAIRE: "yesno",
    RATING_QUESTIONNAIRE: "rating",

    // Legacy / Compartido
    MENU: "menu",
    COURSE: "course",
    COURSES: "courses",
    NEWSLETTER: "newsletter",
    POSTS: "posts",
    POST: "post",
    ASSISTANCE: "assistanteduca",
    ASSISTANCES: "assistanteduca",
    THREAD: "thread",
    THREADGET: "threadGet",
    THREADEDUCA: "threadEduca",
    THREADGETEDUCA: "threadGetEduca",
    CLIENTDB: "clientdb",
    CLIENTSDB: "clientsdb",
    THREEJSIA: "threejs",
    GETTEXT_TO_SPEECH: "speechToText",
    SCENEFILE: "virtualscene/uploadimage",
    SCENEREPO: "virtualscene/uploadrepo",
    HUBROOMS: "roomshub",
    LOADROOMS: "roomshub/load",
    CONTACT: "contacts",
  },

  JWT: {
    ACCESS: "access",
    REFRESH: "refresh",
  },
  USER: {
    ID: "user_id",
    CODE: "user_code",
  },
};
